<template>
  <ul :data-test-id="props.testId ? `${props.testId}-menu` : false" class="menu flex flex-col gap-2">
    <slot />
  </ul>
</template>
<script lang="ts" setup>
import './ItemStyles.css';

export interface MenuData {
  testId?: string;
}

const props = defineProps<MenuData>();
</script>

<style>
.menu li a {
  @apply select-none flex items-center gap-2 leading-4 hover:bg-slate-100 dark:hover:bg-zinc-700 active:bg-slate-300 px-2.5 py-1 font-bold text-slate-600 dark:text-zinc-300 dark:hover:text-zinc-300 rounded-10 focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none;
}
</style>
